import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(['category', 'contact']),
        getByCategory: state => category => {
          return state.objs.filter(ocp => ocp.category === category);
        },
        getByContact: state => contact => {
          return state.objs.filter(ocp => ocp.contact === contact);
        }
    },
    mutations: {
        ...functions.createDefaultMutations(['category', 'contact'])
    },
    actions: {
        ...functions.createDefaultActionsWithStore(['category', 'contact'])
    },
}